import { render, staticRenderFns } from "./ExemptList.vue?vue&type=template&id=e2c0a828"
import script from "./ExemptList.vue?vue&type=script&lang=js"
export * from "./ExemptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports